import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../redux/hooks.js';
import { authErrorSelector } from '../../../redux/core/authError/authErrorSlice.js';
export const LoginAlert = () => {
    const { t } = useTranslation();
    const { source, message, code } = useAppSelector(authErrorSelector);
    if (!source) {
        return null;
    }
    const labelKey = `loginregistration.twoStepLoginRegistration.alert.${source}`;
    // TODO: check for more error types for apple - if they are handled correctly
    // e.g. popup_closed_by_user, if so we need to update translations with correct keys
    const errorCode = typeof code === 'object' && code !== null && 'error' in code
        ? code.error
        : code;
    const labelKeyWithCode = errorCode ? `${labelKey}.${errorCode}` : labelKey; //
    const labelKeyWithCodeAndMessage = message
        ? `${labelKeyWithCode}.${message}`
        : labelKeyWithCode;
    return (_jsx(Alert, { variant: 'negative', mb: 'spaceL', isDismissible: false, children: t(labelKeyWithCodeAndMessage) }));
};
//# sourceMappingURL=LoginAlert.js.map